import request from "@/utils/request";
export function fetchList(query) {
    return request({
        url: '/admin/app/getNewList',
        method: 'get',
        params: query
    })
}

export function fetchDetail(query) {
    return request({
        url: '/admin/app/getNewInfo',
        method: 'get',
        params: query
    })
}

export function fetchSixList(query) {
    return request({
        url: '/admin/app/getNewListLast',
        method: 'get',
        params: query
    })
}

